export default function authHeader(contentType = "application/vnd.api+json") {
  let user = JSON.parse(localStorage.getItem("userF"));

  if (user) {
    return {
      Authorization: "Bearer " + user,
      "Content-Type": contentType,
    };
  } else {
    return {};
  }
}
